export const blobToDataUrl = (blob: Blob) => new Promise<string>((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result as string);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

export const blobToBase64 = (blob: Blob) => blobToDataUrl(blob).then(text => text.slice(text.indexOf(",")+1));
